import { JSONValue } from '../types';

let controller = null;

export async function fetchGridRows(url: string, body: JSONValue) {
  if (controller) {
    controller.abort('Cancel previous request');
  }

  controller = new AbortController();
  const signal = controller.signal;
  const result = await fetch(url, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
    body: JSON.stringify(body),
    signal,
  });
  if (!result.ok && result.status === 401) {
    return { status: 401, errors: [{ message: 'Session expired' }] };
  }
  const data = await result.json();
  controller = null;
  return data;
}
